import { DialogStackContext } from '@ui/core'
import type { DialogStackContextValue } from '@ui/core'

export type { DialogStackContextValue }
export default DialogStackContext
